'use client'
import {ReactNode} from "react";
import {TageaRouterContext} from "@web-libs/core/routing/application/use-tagea-router.concern";
import {useProvideTageaRouter} from "@web-libs/core/routing/infrastructure/next-router";

export const NextRouterProvider = ({children}:{children: ReactNode}) => {
    const nextRouter = useProvideTageaRouter()
    return <TageaRouterContext.Provider value={nextRouter}>{children}</TageaRouterContext.Provider>
}
